<template>
  <div>
    <ValidationObserver ref="addressInfo">
      <b-row class="mt-5">
        <b-col md="6">
          <b-form>
            <b-form-group
              class="d-flex general-info-form-group primary-dark full-width-form"
              label="General Info"
            >
              <b-card no-body class="d-flex mb-5">
                <b-card-body>
                  <div class="d-flex flex-wrap">
                    <b-row class="w-100 my-0 mx-auto" v-if="role === 'admin'">
                      <b-col class="mb-4">
                        <ValidationProvider
                          name="Job Title"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-group label="Job Title*">
                            <b-form-select
                              v-model="selectedJobTitle"
                              :options="jobTitleOptions"
                            ></b-form-select>
                          </b-form-group>
                          <h6
                            v-if="errors[0]"
                            class="font-sm font-family-regular position-absolute danger"
                          >
                            {{ errors[0] }}
                          </h6>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row class="w-100 my-0 mx-auto" v-if="!showInactive">
                      <b-col class="w-100" v-if="role === 'admin'">
                        <b-form-group label="Inactive from">
                          <vue-monthly-picker
                            v-model="selectedMonthFrom"
                            :monthLabels="monthsList"
                            selectedBackgroundColor="#074f89"
                            :min="momentFrom"
                            dateFormat="MM/YYYY"
                            :clearOption="false"
                            @selected="fromSelected"
                          ></vue-monthly-picker>
                        </b-form-group>
                      </b-col>
                      <b-col v-if="role === 'admin'">
                        <b-form-group label="Inactive to">
                          <vue-monthly-picker
                            v-model="selectedMonthTo"
                            :clearOption="false"
                            :monthLabels="monthsList"
                            dateFormat="MM/YYYY"
                            selectedBackgroundColor="#074f89"
                            :min="momentTo"
                          ></vue-monthly-picker>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-else> </b-row>

                    <b-row class="w-100 my-0 mx-auto" v-if="showInactive">
                      <b-col class="w-100" v-if="role === 'admin'">
                        <b-form-group label="Inactive from">
                          <vue-monthly-picker
                            v-model="selectedMonthFrom"
                            dateFormat="MM/YYYY"
                            :monthLabels="monthsList"
                            selectedBackgroundColor="#074f89"
                            :min="momentFrom"
                            @selected="fromSelected"
                            :clearOption="false"
                          ></vue-monthly-picker>
                        </b-form-group>
                      </b-col>
                      <b-col v-if="role === 'admin'">
                        <b-form-group label="Inactive to">
                          <vue-monthly-picker
                            dateFormat="MM/YYYY"
                            v-model="selectedMonthTo"
                            :monthLabels="monthsList"
                            :clearOption="false"
                            selectedBackgroundColor="#074f89"
                            :min="momentTo"
                          ></vue-monthly-picker>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-else> </b-row>
                    <b-row class="w-100 my-0 mx-auto">
                      <b-col class="mb-3">
                        <ValidationProvider
                          name="Specialities field"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-group label="Specialities *">
                            <b-form-input
                              autocomplete="off"
                              size="lg"
                              type="text"
                              :disabled="!isSelf"
                              v-model="specialities"
                              placeholder="Enter specialities"
                            ></b-form-input>
                            <h6
                              v-if="errors[0]"
                              class="font-sm font-family-regular position-absolute danger"
                            >
                              {{ errors[0] }}
                            </h6>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-form-group>
          </b-form>
          <b-form>
            <b-form-group
              class="d-flex primary-dark mb-5 general-info-form-group"
              label="Address info"
            >
              <b-card class="d-flex flex-column general-info-card pt-3">
                <div class="d-flex flex-wrap">
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-5" md="6">
                      <b-form-group label="Country *">
                        <multiselect
                          :disabled="!isSelf"
                          placeholder="Select country"
                          v-model="selectedCountry"
                          label="text"
                          track-by="id"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          hideSelected
                          class="custom-multiselect mb-3 countries-multiselect"
                          :class="[!isSelf ? 'multiselect-disabled' : null]"
                          :options="countries"
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ ellipsify(option.text, 20) }}
                          </template>
                          <template slot="noResult"
                            >No countries found</template
                          ></multiselect
                        >
                      </b-form-group>
                    </b-col>
                    <b-col class="mb-4" md="6">
                      <ValidationProvider
                        name="City field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="City*">
                          <b-form-input
                            v-model="city"
                            placeholder="Enter city name"
                            :disabled="!isSelf"
                            type="text"
                          ></b-form-input>
                          <h6
                            v-if="errors[0]"
                            class="font-sm font-family-regular position-absolute danger"
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-5">
                      <ValidationProvider
                        name="Address line 1"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Address line 1 *">
                          <b-form-input
                            placeholder="Enter address"
                            v-model="address.streetName"
                            :disabled="!isSelf"
                          ></b-form-input>
                        </b-form-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-absolute danger reduce-whitespace-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Address line 2"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Address line 2 *">
                          <b-form-input
                            placeholder="Enter another address"
                            :disabled="!isSelf"
                            v-model="address.streetNumber"
                          ></b-form-input>
                        </b-form-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-absolute danger reduce-whitespace-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-col>
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Postal Code"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Zip code*">
                          <b-form-input
                            placeholder="Enter Zip code"
                            :disabled="!isSelf"
                            v-model="postalCode"
                          ></b-form-input>
                        </b-form-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-absolute danger reduce-whitespace-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="6">
          <div>
            <b-form>
              <b-form-group
                class="d-flex general-info-form-group primary-dark full-width-form"
                label="Communication platforms"
              >
                <b-card
                  v-if="communicationsList.length > 0"
                  no-body
                  class="d-flex flex-column general-info-card mb-5"
                >
                  <b-card-body>
                    <div class="d-flex flex-wrap">
                      <b-row
                        v-for="item in communicationsList"
                        :key="item.id"
                        class="communications-row d-flex align-items-center nowrap w-125"
                      >
                        <b-col
                          style="bottom: 0.5rem;"
                          md="4"
                          class="position-relative"
                        >
                          <div class="communication-type">
                            <img
                              class="position-relative"
                              :src="item.communication.mediumThumbnail"
                              alt
                            />
                            <p
                              :class="[
                                item.communication.medium ===
                                  'Secondary Email' ||
                                item.communication.medium === 'Cell phone'
                                  ? 'reduce-line-height'
                                  : null
                              ]"
                              class="font-weight-normal"
                            >
                              {{ item.communication.medium }}
                            </p>
                          </div>
                        </b-col>

                        <b-col
                          md="8"
                          class="mb-3 communications-textbox position-absolute pr-5"
                        >
                          <b-form-group>
                            <b-form-input
                              autocomplete="off"
                              size="lg"
                              type="text"
                              v-model="item.value"
                              :disabled="!isSelf"
                              placeholder="N/A"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-body>
                </b-card>
                <b-card
                  v-else
                  no-body
                  class="d-flex flex-column general-info-card mb-5"
                >
                  <b-card-body>
                    <div class="d-flex flex-wrap">
                      <b-row
                        v-for="item in communicationIdsList"
                        :key="item.id"
                        class="communications-row d-flex align-items-center nowrap w-125"
                      >
                        <b-col
                          style="bottom: 0.5rem;"
                          md="4"
                          class="position-relative"
                        >
                          <div class="communication-type">
                            <img
                              class="position-relative"
                              :src="item.mediumThumbnail"
                              alt
                            />
                            <p class="font-weight-normal">
                              {{ item.medium }}
                            </p>
                          </div>
                        </b-col>

                        <b-col
                          md="8"
                          class="mb-3 communications-textbox position-absolute pr-5"
                        >
                          <b-form-group>
                            <b-form-input
                              autocomplete="off"
                              size="lg"
                              type="text"
                              v-model="item.value"
                              :disabled="!isSelf"
                              placeholder="N/A"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-body>
                </b-card>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="showValidity">
        <div class="ml-4 mb-3 form-invalid-error-container">
          <p>There are invalid form fields</p>
        </div>
      </b-row>
      <b-row v-else-if="tokenError">
        <div class="ml-4 mb-3 form-invalid-error-container">
          <p>User token expired. Please logout and login again.</p>
        </div>
      </b-row>
      <b-row v-else>
        <div class=" ml-4 mb-3 form-valid-container" v-if="successMessage">
          <p class="font-weight-normal">Profile Updated</p>
        </div>
        <div
          v-if="errorMessage"
          class="ml-4 mb-3 form-invalid-error-container-2"
        >
          <p class="font-weight-normal">Some error occured</p>
        </div>
      </b-row>
      <b-row v-if="isSelf || role === 'admin'">
        <b-button
          class="btn-pill px-5 py-3 mb-5"
          style="margin-left:2rem"
          @click="saveDetails"
        >
          <b-spinner
            v-if="pageLoading"
            style="width: 14px; height: 14px"
            variant="light"
            label="Spinning"
          ></b-spinner>
          {{ `${!pageLoading ? "Save" : ""}` }}
        </b-button>
      </b-row>
    </ValidationObserver>
  </div>
</template>

<script>
import { TEAM_JOB_TITLES } from "@/utils/constants/index";
import moment from "moment";
// import { MonthPickerInput } from "vue-month-picker";
import VueMonthlyPicker from "vue-monthly-picker";
import { email } from "vee-validate/dist/rules";
import { ellipsify, isOwner } from "@/utils/utils";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import Multiselect from "vue-multiselect";
import {
  getCommunicationIDs,
  getCommunications,
  patchAddress,
  patchCommunications,
  postAddress,
  postCommunications,
  saveSpecialities
} from "@/apis/auth";
import {
  getAssistantDetails,
  patchAssistantProfile,
  patchAssitantInactiveDates,
  postAssitantInactiveDates
} from "@/apis/assistants";
import { getAssistantCustomers } from "@/apis/customers";
import { mapState } from "vuex";
import { countriesListJSON, internalCustomerEmailSet } from "@/utils/constants";
extend("email", {
  ...email,
  message: "Email is not valid"
});
extend("required", {
  message: () => "This is a required field"
});
export default {
  name: "PAContactInfo",
  components: {
    ValidationObserver,
    VueMonthlyPicker,
    ValidationProvider,
    Multiselect
  },
  props: {
    isSelf: { type: Boolean, default: false },
    tab: { type: Number, default: 0 },
    contactsTabIndex: { type: Number, default: 1 }
  },
  watch: {
    tab() {
      if (this.tab === this.contactsTabIndex) {
        this.getPAInfo();
        this.showValidity = false;
        this.successMessage = false;
        this.errorMessage = false;
      }
    }
  },
  data() {
    return {
      tokenError: false,
      city: "N/A",
      selectedMonthFrom: "",
      selectedMonthTo: "",
      countries: [],
      selectedCountry: { text: "N/A", id: null },
      postalCode: "N/A",
      showValidity: false,
      profileID: "",
      workHours: "",
      communications: [],
      slackUsername: "",
      zoomUsername: "",
      phoneNumber: "",
      gmail: "",
      successMessage: false,
      errorMessage: false,
      pageLoading: false,
      addressId: "",
      selectedJobTitle: null,
      inactiveDates: [],
      teamJobTitles: [],
      post: true,
      showInactive: false,
      specialities: "N/A",
      monthsList: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
      ],
      communicationIdsList: [],
      momentFrom: "",
      momentTo: "",
      toMonth: "",
      communicationsList: [],
      address: {
        streetName: "N/A",
        streetNumber: "N/A"
      },
      customersList: []
    };
  },
  created() {
    this.getTeamJobTitles();
    this.loadCommunicationIds().then(() => this.getPAInfo());
    this.momentFrom = moment();
    this.momentTo = moment();
    this.countries = countriesListJSON.map(item => {
      return {
        text: item.name,
        id: item.id
      };
    });
  },
  computed: {
    ...mapState("authModule", ["profileUserId", "role"]),
    // The Owner title is only set when the account is created as an Owner -
    // picking it here would change the label without changing the role, so
    // it is offered only to someone who already holds it.
    jobTitleOptions() {
      if (this.selectedJobTitle === "OWNER") return this.teamJobTitles;
      return this.teamJobTitles.filter(title => title.value !== "OWNER");
    },
    // Owner profiles drop the Tasks tab, so Contacts moves from index 2 → 0.
    canEditCommunications() {
      return this.isSelf || this.role === "admin";
    }
  },
  methods: {
    assistantApiRole() {
      return "assistant";
    },
    async loadCommunicationIds() {
      // Owners may not have access to label=all — fall back to assistant.
      const labels = isOwner() ? ["assistant", "all"] : ["all", "assistant"];
      for (const label of labels) {
        try {
          const res = await getCommunicationIDs(label);
          if (res.data.results?.length) {
            this.communicationIdsList = [...res.data.results];
            return;
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    getTeamJobTitles() {
      this.teamJobTitles = [...TEAM_JOB_TITLES];
      this.teamJobTitles.unshift({ text: "Select Job Title", value: null });
    },
    fromSelected(date) {
      this.momentTo = date;
      this.selectedMonthTo = "";
    },
    getSelectedCountry(selected) {
      this.selectedCountry = selected.text;
    },
    ellipsify,
    getPAInfo() {
      getAssistantDetails(this.$route.params.uuid)
        .then(res => {
          let { profile, user, communications, addresses } = res.data;
          this.workHours = Number(profile.workHours) || "N/A";
          this.selectedJobTitle = profile.jobTitle;
          this.profileID = profile.id;
          this.specialities = profile.specialities || "N/A";
          this.paFullname = `${user.firstName} ${user.lastName} `;
          this.userAvatar = user.avatarThumbnail || null;
          this.userInitials = `${user.firstName} ${user.lastName}`;
          this.userInitials = this.userInitials.match(/\b(\w)/g).join("");
          this.inactiveDates = [...res.data.inactiveDates];
          if (res.data.inactiveDates.length > 0) {
            this.showInactive = true;
            this.momentTo = moment(this.inactiveDates[0].inactiveFrom);
            this.selectedMonthFrom = moment(this.inactiveDates[0].inactiveFrom);
            this.selectedMonthTo = moment(this.inactiveDates[0].inactiveTo);
          }
          if (addresses?.length) {
            const { country } = addresses[0];
            this.selectedCountry = this.countries.filter(
              item => item.text === country
            )[0];
            this.post = false;
            this.addressId =
              res.data.addresses[res.data.addresses.length - 1].id;
          }
          if (communications.length > 0) {
            this.communicationsList = communications;
          } else if (this.canEditCommunications()) {
            const payloadData = this.communicationIdsList.map(item => ({
              communication: item.id,
              value: ""
            }));
            postCommunications(
              this.$route.params.uuid,
              payloadData,
              this.assistantApiRole()
            )
              .then(() => {
                return getCommunications(
                  this.$route.params.uuid,
                  this.assistantApiRole()
                );
              })
              .then(res => {
                this.communicationsList = [...res.data.results];
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            getCommunications(
              this.$route.params.uuid,
              this.assistantApiRole()
            )
              .then(res => {
                this.communicationsList = [...res.data.results];
              })
              .catch(err => {
                console.log(err);
              });
          }
          res.data.addresses.forEach(item => {
            this.city = item.city || "N/A";
            this.selectedCountry = this.countries.filter(
              iter => iter.text === item.country
            );
            this.address.streetName = item.address.streetName;
            this.address.streetNumber = item.address.streetNumber;
            this.postalCode = item.postalCode;
          });
          getAssistantCustomers(res.data.id)
            .then(res => {
              this.customersList = [...res.data.results]
                .map(item => {
                  let {
                    firstName,
                    lastName,
                    email
                  } = item.customer.profile.user;
                  item.customerEmail = email;
                  item.customerFullname = `${firstName} ${lastName} `;
                  item.customerInitials = item.customerFullname
                    .match(/\b(\w)/g)
                    .join("");
                  return item;
                })
                .filter(
                  el =>
                    !internalCustomerEmailSet.has(
                      el.customer.profile.user.email
                    )
                );
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err.response);
          this.$emit("showLoader", false);
        })
        .finally(() => {
          this.$emit("showLoader", false);
        });
    },
    async saveDetails() {
      this.showValidity = false;
      this.tokenError = false;
      if (this.role === "admin") {
        this.pageLoading = true;
        const data = {
          inactiveFrom: moment(this.selectedMonthFrom).format("YYYY-MM-DD"),
          inactiveTo: moment(this.selectedMonthTo).format("YYYY-MM-DD"),
          profile: this.$route.params.uuid
        };
        if (
          this.selectedMonthFrom.length !== 0 &&
          this.selectedMonthTo.length !== 0
        ) {
          if (this.inactiveDates.length === 0) {
            postAssitantInactiveDates(this.$route.params.uuid, data)
              .then(() => {
                console.log("success");
              })
              .catch(err => {
                if (err.response.status === 401) {
                  this.tokenError = true;
                }
              });
          } else {
            patchAssitantInactiveDates(
              this.$route.params.uuid,
              this.inactiveDates[0].id,
              data
            )
              .then(() => {
                console.log("success");
              })
              .catch(err => {
                if (err.response.status === 401) {
                  this.tokenError = true;
                }
              });
          }
        }
        patchAssistantProfile(this.$route.params.uuid, this.profileID, {
          jobTitle: this.selectedJobTitle
        })
          .then(() => {
            this.pageLoading = false;
            this.successMessage = true;
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.tokenError = true;
            }
            this.pageLoading = false;
          });
      } else {
        const valid = await this.$refs.addressInfo.validate();
        if (valid) {
          this.pageLoading = true;
          if (this.post) {
            this.saveAddress();
          } else {
            this.patchAddress();
          }
          this.patchCommunications();
          const data = {
            specialities: this.specialities
          };
          saveSpecialities(this.profileUserId, this.profileID, data)
            .then(() => {})
            .catch(err => {
              if (err.response.status === 401) {
                this.tokenError = true;
              }
              this.pageLoading = false;
            });
        } else {
          this.showValidity = true;
        }
      }
    },
    patchCommunications() {
      let data = [];
      for (let i = 0; i < this.communicationsList.length; i++) {
        data.push({
          id: this.communicationsList[i].id,
          value: this.communicationsList[i].value
        });
      }
      patchCommunications(this.$route.params.uuid, data, "assistant")
        .then(() => {
          this.successMessage = true;
          this.pageLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.showCommunications = true;
        });
    },
    saveAddress() {
      const address = {
        streetNumber: this.address.streetNumber,
        streetName: this.address.streetName
      };
      const data = {
        city: this.city,
        country: this.selectedCountry.text,
        address: address,
        postalCode: this.postalCode
      };
      postAddress(this.profileUserId, data, "assistant")
        .then(() => {})
        .catch(err => {
          console.log(err.response);
        });
    },

    patchAddress() {
      const address = {
        streetNumber: this.address.streetNumber,
        streetName: this.address.streetName
      };
      const data = {
        city: this.city,
        country: this.selectedCountry.text,
        address: address,
        postalCode: this.postalCode
      };
      patchAddress(this.profileUserId, data, this.addressId, "assistant")
        .then(() => {})
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;

<style scoped lang="scss">
.communications-row:first-child {
  margin-top: 2rem;
}
.communications-row:not(:first-child) {
  margin-top: 1.5rem;
}
.communications-row {
  padding-bottom: 15px;
}
.communications-row:last-child {
  padding-bottom: 6px;
}
.communications-textbox {
  right: 0;
}
.communication-icons {
  width: 40px;
  height: 40px;
}
.communication-icons img {
  object-fit: cover;
  width: inherit;
  position: relative;
  bottom: 0rem;
}
.communication-type {
  padding-left: 15px;
  img {
    display: none;
  }
}
</style>
